import { animate, state, style, transition, trigger } from '@angular/animations';

// General Height Transitions
export const transitionHeight = trigger('transitionHeight', [
  state('void', style({ height: '0', opacity: '0', overflow: 'hidden' })),
  state('*', style({ height: '*', opacity: '1', overflow: 'hidden' })),
  transition('void <=> *', [animate('.2s ease-in-out')]),
]);

export const appearHeight = trigger('appearHeight', [
  transition(':enter', [style({ maxHeight: 0, opacity: 0 }), animate('.2s ease-out', style({ maxHeight: '300px', opacity: 1 }))]),
  transition(':leave', [style({ maxHeight: '300px', opacity: 1 }), animate('.2s ease-out', style({ maxHeight: 0, opacity: 0 }))]),
]);

// General Width Transitions
export const transitionWidth = trigger('transitionWidth', [
  state('void', style({ width: '0', opacity: '0', overflow: 'hidden' })),
  state('*', style({ width: '*', opacity: '1', overflow: 'hidden' })),
  transition('void <=> *', [animate('.2s ease-in-out')]),
]);

export const appearWidth = trigger('appearWidth', [
  transition(':enter', [style({ opacity: 0 }), animate('.2s ease-out', style({ opacity: 1 }))]),
  transition(':leave', [style({ maxWidth: '300px', opacity: 1 }), animate('.4s ease-out', style({ maxWidth: 0, opacity: 0 }))]),
]);

// Entity & Button Transitions
export const entityButtonsAppear = trigger('entityButtonsAppear', [
  transition(':enter', [style({ opacity: 0 }), animate('200ms ease-out', style({ opacity: 1 }))]),
]);

export const buttonInOut = trigger('buttonInOut', [
  transition(':enter', [style({ maxHeight: '0', padding: '0' }), animate('.2s ease-out', style({ maxHeight: '45px', padding: '10px' }))]),
  transition(':leave', [style({ maxHeight: '45px', padding: '10px' }), animate('.2s ease-out', style({ maxHeight: '0', padding: '0' }))]),
]);

// Config, Message, and Select Transitions
export const configSectionsInOut = trigger('configSectionsInOut', [
  transition(':enter', [style({ maxHeight: '0' }), animate('.7s ease-out', style({ maxHeight: '400px' }))]),
  transition(':leave', [style({ maxHeight: '400px' }), animate('.3s ease-out', style({ maxHeight: '0' }))]),
]);

export const selectInOut = trigger('selectInOut', [
  transition(':enter', [style({ width: '0', border: '0' }), animate('.2s ease-out', style({ width: '100%', border: 'initial' }))]),
]);

export const messageInOut = trigger('messageInOut', [
  transition(':enter', [style({ maxHeight: '0' }), animate('.7s ease-out', style({ maxHeight: '400px' }))]),
  transition(':leave', [style({ maxHeight: '400px' }), animate('.3s ease-out', style({ maxHeight: '0' }))]),
]);

// List & Recent Activity Transitions
export const transitionNewLiInOut = trigger('transitionNewLiInOut', [
  transition(':enter', [style({ height: '0', opacity: '0' }), animate('.15s ease-out', style({ height: '25px', opacity: '1' }))]),
  transition(':leave', [style({ height: '25px', opacity: '1' }), animate('.15s ease-out', style({ height: '0', opacity: '0' }))]),
]);

export const transitionRecentActivity = trigger('transitionRecentActivity', [
  transition(':enter', [style({ maxHeight: '0' }), animate('.2s ease-out', style({ maxHeight: '246px' }))]),
  transition(':leave', [style({ maxHeight: '246px' }), animate('.2s ease-out', style({ maxHeight: '0' }))]),
]);
